
import moment from 'moment';

import React, { Component } from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { UserContext, hasAccountPermission } from 'components/User';
import { YellowButton } from 'ui/Button';
import { Grid } from 'ui/Grid';
import { H1 } from 'ui/Typography';
import { DateDayWidget } from 'form/new/DateDayWidget';


const StyledLayoutHeader = styled.div`
  padding: 20px 30px;
  
  @media (max-width: 1279px) {
    padding: 10px 10px;
  }
  
  h1 {
    margin: 0;
  }
  
  .header-container {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }

  .filters-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
  
  .right-container {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 10px;
  }
`;

const StyledLayoutHeaderDivider = styled.div`
  padding: 20px 0 0 0;
  
  &:after {
    content: ' ';
    display: block;
    height: 1px;
    background: #EDEDED;
  }
`;


export default class PlanningListHeader extends Component {

  static contextType = UserContext;

  getAddLink = () => {
    const { view, filter } = this.props;
    if (view === 'selection' && filter && filter.dateStart) {
      const dateStartParam = moment(filter.dateStart).format('YYYY-MM-DD');
      return `/planning/add?date_start=${dateStartParam}`;
    }
    return '/planning/add';
  };

  render() {
    const {
      view,
      history,
      filter,
      onDateChange,
      onFiltersClick,
    } = this.props;
    const isGeneral = view === 'general';
    const isSelection = view === 'selection';

    return (
      <StyledLayoutHeader>
        <Grid columns={'1fr auto'} tabletColumns={'1fr auto'} mobileColumns={'1fr'}>
          <div className={'filters-row'}>
            <H1>Планирование</H1>

            {isGeneral && (
              <div className={'header-container'}>
                <Button
                  variant={'outlined'}
                  onClick={onFiltersClick}
                >
                  Фильтры
                </Button>
              </div>
            )}

            {isSelection && (
              <div className={'header-container'}>
                <DateDayWidget
                  value={filter && filter.dateStart}
                  onChange={onDateChange}
                  size={'small'}
                />
              </div>
            )}
          </div>

          <div className={'right-container'}>
            <div className={'header-container'}>
              <ButtonGroup variant={'outlined'}>
                <Button
                  disabled={isGeneral}
                  onClick={() => history.push('/planning')}
                >
                  Общий
                </Button>
                <Button
                  disabled={isSelection}
                  onClick={() => history.push('/planning/selection')}
                >
                  Подбор ТС
                </Button>
              </ButtonGroup>

              {hasAccountPermission(this.context, 'order.add_order') && (
                <YellowButton
                  to={this.getAddLink()}
                  component={Link}
                >
                  Добавить перевозку
                </YellowButton>
              )}
            </div>
          </div>
        </Grid>

        <StyledLayoutHeaderDivider />
      </StyledLayoutHeader>
    );
  }
}
